package dev.lingvo.site.components.editor

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.attr
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import dev.lingvo.shared.isCanonicalSourceReviewId
import dev.lingvo.site.ds.LAlert
import dev.lingvo.site.ds.LAlertVariant
import dev.lingvo.site.ds.LButton
import dev.lingvo.site.ds.LButtonSize
import dev.lingvo.site.ds.LButtonVariant
import dev.lingvo.site.ds.LMuted
import dev.lingvo.site.ds.Space
import dev.lingvo.site.i18n.t

@Composable
internal fun EditorRequestedKeySurface(state: TranslationEditorState) {
    val requested = state.requestedKey
    requested.failure?.let { failure ->
        LAlert(
            title = t("editor.editor_requested_key_surface.requested_string_not_loaded", "Requested string not loaded"),
            description = failure, variant = LAlertVariant.WARNING,
            modifier = Modifier.fillMaxWidth().attr("data-editor-requested-key-error", "true"),
            action = {
                Column(Modifier.gap(Space.SM)) {
                    LButton(t("editor.editor_requested_key_surface.retry_requested_string", "Retry requested string"), requested::retry,
                        variant = LButtonVariant.GHOST, size = LButtonSize.SM, loading = requested.loading)
                    requested.pendingId?.takeIf(::isCanonicalSourceReviewId)?.let { key ->
                        LButton(t("editor.editor_requested_key_surface.inspect_requested_string", "Inspect requested string"),
                            { state.navigateTo("/app/projects/${encodeURIComponent(state.projectSlug)}/strings/${encodeURIComponent(key)}") },
                            modifier = Modifier.attr("data-editor-requested-key-inspect", "true"),
                            variant = LButtonVariant.GHOST, size = LButtonSize.SM)
                    }
                }
            },
        )
    }
    if (requested.loading && requested.failure == null) LMuted(
        t("editor.editor_requested_key_surface.loading_requested_string", "Loading the requested string…"),
        modifier = Modifier.attr("role", "status"),
    )
    if (requested.outsideLoadedQueue) LMuted(t("editor.editor_requested_key_surface.loaded_directly", "This string was loaded directly. It is not included in the rows currently shown in the queue."))
}

private external fun encodeURIComponent(value: String): String
